export enum MetaStatusEnum {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED',
  NEVER_SENT = 'NEVER_SENT'
}
